export const addMedToPacketsDefault = '{\n' +
    '    "contractId": ""\n' +
    '    "programName": "AP_PILLPACK"\n' +
    '    "version": ""\n' +
    '    "itemManipulationEntityAction": "ADD"\n' +
    '    "drugId": ""\n' +
    '}';

export interface IAddMedToPacketsRequest {
    contractId: string
    programName: string
    version: string
    itemManipulationEntityAction: string
    drugId: string
    enrollmentOptions?: IEnrollmentOptions
}

export interface IEnrollmentOptions {
    prescriptionlessDrugData: IPrescriptionlessDrugData
}

export interface IPrescriptionlessDrugData {
    fulfillableProductAsin: string
    quantityPerDay?: string
    quantityPerDose?: string
}